export default __webpack_public_path__ + "static/media/hundredEmoji.5d9d25b0.svg";